import { apiGetTeamStatics, RespTeamStatics } from '@vas2t-lowcode/api';
import type { AxiosPromise } from 'axios';
import { useRouter } from 'vue-router';

let teamStaticsReq = undefined as undefined | AxiosPromise<RespTeamStatics>;

/**
 * 获取预加载的数据
 *
 * @returns
 */
export const reqTeamStaticsAsync = () => {
  if (!teamStaticsReq) {
    teamStaticsReq =
      window._reqTeamStaticsAsync?.catch((err: any) => {
        // 针对 index.html的请求逻辑执行特殊逻辑处理
        let code = '';
        try {
          code = JSON.parse(err?.message || '{}')?.result || '';
        } catch (e) {
          console.error(e);
          console.warn(err);
        }

        if (['err_team_member_disabled', 'err_invalid_team_member'].indexOf(code) !== -1) {
          const router = useRouter();
          // 非法团队成员则返回首页
          router?.push({ path: '/home', force: true }).finally(() => {
            location.reload();
          });
          return;
        }
      }) || apiGetTeamStatics();
    return teamStaticsReq;
  }

  return teamStaticsReq;
};

/**
 * 重置预加载的数据, 防止下次reqBannerTopDataAsync获取的为旧数据
 *
 * @returns
 */
export const resetTeamStaticsAsync = () => {
  teamStaticsReq = undefined;
  window._reqTeamStaticsAsync = undefined;
};
